import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import { REDEEM_REQUEST, REDEEM_COUNT } from "../actions/types";
import {
  redeemClosePopup,
  redeemOpenFail,
  redeemCountSuccess,
  redeemOpenSuccess,
} from "../actions/RedeemActions";
import { authorizationHeader, getErrorMessage_v2 } from "../utils/apiUtil";
import axios from "axios";
import axiosRetry from "axios-retry";

import { authSignOutSuccess } from "../actions/AuthActions";
import { walletDetailFetchSuccess } from "../actions";
import { walletDetailFetchRequest } from "../sagas/WalletSagas";
import { push } from "react-router-redux";

axiosRetry(axios, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const redeemRequestApi = async ({ formValues, id }) => {
  const inputData = {
    privilege_id: id,
    firstname: "",
    lastname: "",
    input_data: formValues,
  };
  return await axios
    .post(`${REACT_APP_API_URL}/client/v1/redemption/redeem`, inputData, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const redeemCountRequest = async (id) => {
  return await axios
    .get(`${REACT_APP_API_URL}/v1/member/redeemCount`, {
      headers: authorizationHeader("Bearer"),
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};
// WORKER

function* redeemRequest({ payload }) {
  try {
    const data = yield call(redeemRequestApi, payload);
    if (data.result == true) {
      const callPoint = yield call(walletDetailFetchRequest, {});
      yield put(walletDetailFetchSuccess(callPoint));
      yield put(redeemOpenSuccess(data.redeem.redemption.id));
    } else if (data.status == true) {
      const callPoint = yield call(walletDetailFetchRequest, {});
      yield put(walletDetailFetchSuccess(callPoint));
      //  "/my-coupon/"  + data.redemption.redemption.id
      yield put(push("/my-coupon/" + data.redemption.redemption.id));
    } else {
      yield put(redeemOpenFail());
    }
  } catch (error) {
    if (
      error.response &&
      error.response.status &&
      error.response.status === 401
    ) {
      localStorage.removeItem("member");
      yield put(authSignOutSuccess());
    } else {
      yield put(redeemClosePopup());
      yield put(redeemOpenFail());
    }
  }
}

function* redeemCount({ payload }) {
  try {
    const data = yield call(redeemCountRequest, payload);
    if (data.redeem_count.length) {
      yield put(redeemCountSuccess(data.redeem_count.length));
    }
  } catch (error) {}
}

// WATCHER

export function* redeemRequestFetchWatcher() {
  yield takeEvery(REDEEM_REQUEST, redeemRequest);
}

export function* redeemCounthWatcher() {
  yield takeEvery(REDEEM_COUNT, redeemCount);
}

export default function* rootSaga() {
  yield all([fork(redeemRequestFetchWatcher), fork(redeemCounthWatcher)]);
}
